<template>
  <div class="auth-page">
    <a-card :bordered="false">
      <div class="config-layout">
        <!-- 右侧内容区 -->
        <div class="main-content">
          <!-- 操作按钮 -->
          <div class="operation-bar">
            <a-button type="primary" @click="showAddModal">新增认证</a-button>
          </div>
          
          <!-- 表格 -->
          <a-table :columns="columns" :data-source="dataSource" :pagination="pagination">
            <template #bodyCell="{ column }">
              <template v-if="column.key === 'action'">
                <a>编辑</a>
              </template>
            </template>
          </a-table>
        </div>
      </div>
    </a-card>

    <!-- 新增认证对话框 -->
    <a-modal
      v-model:visible="modalVisible"
      title="新增开放认证"
      @ok="handleModalOk"
      @cancel="handleModalCancel"
      :maskClosable="false"
    >
      <a-form :model="formState" :label-col="{ span: 6 }" :wrapper-col="{ span: 16 }">
        <a-form-item label="自定义编码" required>
          <a-input v-model:value="formState.code" placeholder="请输入自定义编码" />
        </a-form-item>

        <a-form-item label="绑定权限用户" required>
          <a-select
            v-model:value="formState.bindUser"
            placeholder="请输入绑定权限用户"
            show-search
          >
            <!-- 用户选项可以从后端获取 -->
          </a-select>
        </a-form-item>

        <a-form-item label="IP白名单">
          <div v-for="(ip, index) in formState.ipList" :key="index" class="ip-input-row">
            <a-input v-model:value="formState.ipList[index]" placeholder="请输入 IP 地址" />
            <a-button type="link" danger @click="removeIp(index)" class="remove-btn">
              <delete-outlined />
            </a-button>
          </div>
          <a-button type="link" class="add-ip-btn" @click="addNewIp">
            <plus-outlined /> 添加新IP白名单
          </a-button>
        </a-form-item>

        <a-form-item label="秘钥自动生成">
          <a-switch v-model:checked="formState.autoGenerateKey" />
        </a-form-item>

        <a-form-item v-if="!formState.autoGenerateKey" label="密钥">
          <a-input-password v-model:value="formState.secretKey" placeholder="请输入密钥" />
        </a-form-item>

        <a-form-item label="描述">
          <a-textarea
            v-model:value="formState.description"
            placeholder="请输入描述"
            :rows="4"
          />
        </a-form-item>
      </a-form>
    </a-modal>
  </div>
</template>

<script setup lang="ts">
import { ref, reactive } from 'vue'
import { DeleteOutlined, PlusOutlined } from '@ant-design/icons-vue'
import SystemSideMenu from '@/components/SystemSideMenu.vue'

// 表格列定义
const columns = [
  {
    title: '编号',
    dataIndex: 'id',
    key: 'id'
  },
  {
    title: '编码',
    dataIndex: 'code',
    key: 'code'
  },
  {
    title: '绑定账号',
    dataIndex: 'bindAccount',
    key: 'bindAccount'
  },
  {
    title: '绑定账号ID',
    dataIndex: 'bindAccountId',
    key: 'bindAccountId'
  },
  {
    title: 'IP白名单',
    dataIndex: 'ipWhitelist',
    key: 'ipWhitelist'
  },
  {
    title: '描述',
    dataIndex: 'description',
    key: 'description'
  },
  {
    title: '操作',
    key: 'action',
    width: 80
  }
]

// 表格数据
const dataSource = ref([])

// 分页配置
const pagination = {
  total: 0,
  current: 1,
  pageSize: 10,
  showTotal: (total: number) => `共 ${total} 条`
}

// 对话框显示控制
const modalVisible = ref(false)

// 表单数据
// 表单数据
const formState = reactive({
  code: '',
  bindUser: undefined,
  ipList: [''], // 初始化一个空的 IP 输入框
  autoGenerateKey: true,
  secretKey: '', // 新增密钥字段
  description: ''
})

// 显示新增对话框
const showAddModal = () => {
  modalVisible.value = true
}

// 添加新的 IP 输入框
const addNewIp = () => {
  formState.ipList.push('')
}

// 删除指定的 IP 输入框
const removeIp = (index: number) => {
  formState.ipList.splice(index, 1)
}

// 确认提交
const handleModalOk = () => {
  // 处理表单提交逻辑
  console.log('表单数据：', formState)
  modalVisible.value = false
}

// 取消提交
const handleModalCancel = () => {
  modalVisible.value = false
  // 重置表单数据
  formState.code = ''
  formState.bindUser = undefined
  formState.ipList = [''] 
  formState.autoGenerateKey = true
  formState.secretKey = '' // 重置密钥
  formState.description = ''
}
</script>

<style lang="less" scoped>
.auth-page {
  padding: 24px;
  background: #f5f7f9;
  min-height: calc(100vh - 112px);

  .config-layout {
    display: flex;
    
    .side-menu {
      width: 220px;
      background: #fff;
      border-radius: 4px;
      margin-right: 16px;
      padding: 16px 0;
      min-height: 600px;
      border: 1px solid #e8e8e8;
    }

    .main-content {
      flex: 1;
      background: #fff;
      border-radius: 4px;
      padding: 24px;
      border: 1px solid #e8e8e8;

      .operation-bar {
        margin-bottom: 16px;
      }
    }
  }
}

.ip-input-row {
  display: flex;
  align-items: center;
  margin-bottom: 8px;

  .ant-input {
    flex: 1;
  }

  .remove-btn {
    margin-left: 8px;
    padding: 4px 8px;
  }
}

.add-ip-btn {
  padding: 0;
  height: auto;
  line-height: 1;
  color: #1890ff;

  .anticon {
    margin-right: 4px;
  }
}
</style>